<template>
  <div>
    <LmListV2
      ref='LmEmailTemplatesListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Email Templates',
      gqlField: 'mailerTemplate',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[MailertemplateESSortEnum]) {
          mailerTemplate(
            titleList: "Email Templates"
            q: $q
            perPage: 10
            page: $page
            sort: $sort
            metaSearch: "*"
            opts: {
                lenient: true
            }
            lmPathActions: [{to:"/FormBuilderUi/preview/615c4a4a2782e142c8615cfb/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
            lmModalActions: []
            buttonLinks: [{value:"Nuevo",to:"/FormBuilderUi/preview/615c4a4a2782e142c8615cfb/",buttonClass:"btn-info"}]
            ) {
            count
            searcher
            tableItemsTotal
            titleList
            table {
                items {
                    name,type,published,createdAt,updatedAt,actions
                }
                fields {
                    key
                    label
                    sortable
                }
            }
            buttons
            pagination
        }
    }`,
      searchOnFieldsSelected: [
        '_id',
        'name',
        'type',
        'published',
        'createdAt',
        'updatedAt',
        'actions'
      ],
      searchOnFieldsToSelected: [
        'name',
        'type',
        'published',
        'createdAt',
        'updatedAt',
        'actions'
      ],
      items: [
        {
          name: 'id'
        },
        {
          name: name
        },
        {
          name: 'type'
        },
        {
          name: 'published'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'actions'
        }
      ],
      mode: {
        table: true,
        map: false
      },
      fields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'type',
          label: 'Tipo',
          sortable: false
        },
        {
          key: 'published',
          label: 'Publicado',
          sortable: false
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: 'Actualizado',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
